import { useTranslation } from 'react-i18next';

import { SingleLineText, Title, LogoutButton, WithErrorBoundary } from '@bloomays-lib/ui.shared';
import RawMailOutlineIcon from '@mui/icons-material/MailOutline';
import { styled } from '@mui/material/styles';
import { useAuthStore } from '../../stores';

const NoRole = () => {
  const { t } = useTranslation(['random', 'verifyYourMail']);
  const auth = useAuthStore((state) => state.auth);

  return (
    <ContainerDiv>
      <Title textTitle={t('verifyYourMail', { ns: 'firstCo' })} />
      <MailOutlineIcon />
      <SingleLineText text={t('verify', { ns: 'firstCo' })} />
      <SingleLineText text={t('emailVerified', { ns: 'firstCo' })} />
      <LogoutButton logout={() => auth?.logout()} textButton="Se reconnecter" type="button" />
    </ContainerDiv>
  ) as React.ReactNode;
};

export default WithErrorBoundary(NoRole);

const ContainerDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  backgroundColor: theme.palette.neutral.white,
  boxShadow: `2px 2px 20px ${theme.palette.neutral[10]}`,
  borderRadius: '10px',
  width: '40%',
  margin: '1em auto',
  padding: '1em',
  [theme.breakpoints.down('md')]: {
    width: '85%',
  },
}));

const MailOutlineIcon = styled(RawMailOutlineIcon)(({ theme }) => ({
  color: theme.palette.blue[60],
  fontSize: '130px !important',
  margin: 'auto',
}));
